import {
  CreateSolvemateChatbotConfigurationApiResponse,
  ReadMimChatbotConfigurationByIdApiResponse,
} from 'apis/chatbots';

import {
  CreateAdaChatbotConfigurationApiResponse,
  CreateMimChatbotConfigurationApiResponse,
  ReadChatbotConfigurationsApiResponse,
  ReadMimChatbotConfigurationsApiResponse,
  ReadSolvemateChatbotConfigurationsApiResponse,
} from '../types/chatbotsApi.types';

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the chatbots endpoint.
 */
export function transformReadChatbotConfigurationsResponse(
  response: any,
): ReadChatbotConfigurationsApiResponse {
  return {
    data: {
      chatbots: response,
    },
    meta: {},
  };
}

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the chatbots endpoint.
 */
export function transformCreateAdaChatbotConfigurationResponse(
  response: any,
): CreateAdaChatbotConfigurationApiResponse {
  return {
    data: response,
    meta: {},
  };
}

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the Solvemate chatbots endpoint.
 */
export function transformSolvemateReadChatbotConfigurationsResponse(
  response: any,
): ReadSolvemateChatbotConfigurationsApiResponse {
  return {
    data: {
      chatbots: response,
    },
    meta: {},
  };
}

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the Solvemate chatbots endpoint.
 */
export function transformCreateSolvemateChatbotConfigurationResponse(
  response: any,
): CreateSolvemateChatbotConfigurationApiResponse {
  return {
    data: response,
    meta: {},
  };
}

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the Mim chatbots endpoint.
 */
export function transformReadMimChatbotConfigurationResponse(
  response: any,
): ReadMimChatbotConfigurationByIdApiResponse {
  return {
    data: response,
    meta: {},
  };
}

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the Mim chatbots endpoint.
 */
export function transformReadMimChatbotConfigurationsResponse(
  response: any,
): ReadMimChatbotConfigurationsApiResponse {
  return {
    data: {
      chatbots: response,
    },
    meta: {},
  };
}

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the Mim chatbots endpoint.
 */
export function transformCreateMimChatbotConfigurationResponse(
  response: any,
): CreateMimChatbotConfigurationApiResponse {
  return {
    data: response,
    meta: {},
  };
}
